function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#fb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.442 0H1.6C1.17565 0 0.768686 0.16857 0.468628 0.468628C0.16857 0.768686 0 1.17565 0 1.6V27.442C0 27.6521 0.0413843 27.8602 0.121792 28.0543C0.202199 28.2484 0.320054 28.4248 0.468628 28.5734C0.617202 28.7219 0.793584 28.8398 0.987705 28.9202C1.18183 29.0006 1.38988 29.042 1.6 29.042H14.523V17.635H11.051V13.485H14.523V10.179C14.523 6.428 17.123 4.385 20.476 4.385C22.076 4.385 23.804 4.506 24.205 4.559V8.477H21.535C19.712 8.477 19.364 9.339 19.364 10.61V13.485H23.708L23.141 17.634H19.364V29.045H27.442C27.8663 29.045 28.2733 28.8764 28.5734 28.5764C28.8734 28.2763 29.042 27.8693 29.042 27.445V1.6C29.042 1.17565 28.8734 0.768686 28.5734 0.468628C28.2733 0.16857 27.8663 0 27.442 0V0Z",
  fill: "#008DFF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "fb"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.045,
  height: 29.045,
  fill: "white"
})));

var SvgFacebookLogo = function SvgFacebookLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    className: "cursor-pointer mr-4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FacebookLogo.9a1ade35.svg";
export { ForwardRef as ReactComponent };